import script from "./Folder.vue?vue&type=script&setup=true&lang=ts"
export * from "./Folder.vue?vue&type=script&setup=true&lang=ts"

import "./Folder.vue?vue&type=style&index=0&id=00d54876&scoped=true&lang=css"

import exportComponent from "/Users/alessiomealli/WebstormProjects/switaly/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00d54876"]])

export default __exports__